require('./brokerClientWarningModal.scss');

// @ vendor
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter, Redirect } = require('react-router-dom');
// @ components
const OKModal = require('components/commons/OKModal/OKModal');
const moment = require('moment');
const DateHelper = require('utilities/dateHelper');
const {
    BROKER_LAST_MIFID_DAY,
    HIRE_VALUES_CONTRACT_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ERROR_URL
} = require('constants/index');
// @utils
const { getLeiValidationMessageComponent } = require('utilities/leiValidationMessage');
// @actions
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');

class BrokerClientWarningModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
        };

        this.handleCancelClientWarning = this.handleCancelClientWarning.bind(this);
        this.handleContinueWithClientWarning = this.handleContinueWithClientWarning.bind(this);
        this.handleReturnWallet = this.handleReturnWallet.bind(this);
    }

    handleCancelClientWarning() {
        this.setState({
            redirectTo: null,
        });
        this.props.routerHookCallback();
        this.props.hideClientWarningModal();
        this.props.preventGenerateDocumentError();
    }

    handleContinueWithClientWarning() {
        const hasError = this.props.immbrokerClientWarningModal.get('generateDocumnentError');
        this.props.routerHookCallback();
        this.props.hideClientWarningModal();
        this.setState({
            redirectTo: hasError ? MYPROFILE_BROKER_ERROR_URL : this.props.nextLocation,
        });
        window.modalInstance = null;
    }

    handleReturnWallet() {
        this.props.routerHookCallback();
        this.props.hideClientWarningModal();
        this.props.preventGenerateDocumentError();
        this.setState({
            nextLocation: MYPROFILE_BROKER_URL,
            redirectTo: MYPROFILE_BROKER_URL,
        });
    }

    render() {
        const { immAccessKey, immbrokerClientWarningModal, nextLocation } = this.props;
        const { redirectTo } = this.state;
        const isModalOpen = immbrokerClientWarningModal.get('isOpen');
        let leavingWarningMessage = null;
        const lastAccess = moment(immAccessKey.getIn(['cmcContract', 'lastAccess']));
        const lastMiFIDDay = moment(BROKER_LAST_MIFID_DAY);
        const noOfDaysRemaining = DateHelper.getDaysBetweenDates(lastAccess, lastMiFIDDay);
        let primaryButtonText;
        let secondaryButtonText;
        let onPrimaryButtonClickHandler;
        let onSecondaryButtonClickHandler;

        if (noOfDaysRemaining.length > 0 || nextLocation === HIRE_VALUES_CONTRACT_URL) {
            primaryButtonText = "common-continue";
            secondaryButtonText = "common-cancel";
            onPrimaryButtonClickHandler = this.handleContinueWithClientWarning;
            onSecondaryButtonClickHandler = this.handleCancelClientWarning;
        } else {
            primaryButtonText = "brokerClientWarningModal-returnToMyWallet"
            onPrimaryButtonClickHandler = this.handleReturnWallet;
        }

        const modalContent = (
            <div className="broker-client-warning-modal__modal-text">
                {getLeiValidationMessageComponent(lastAccess)}
            </div>
        );

        if (isModalOpen) {
            leavingWarningMessage = (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={true}
                    onCloseCallback={this.handleCancelClientWarning}
                    onPrimaryButtonClick={onPrimaryButtonClickHandler}
                    onSecondaryButtonClick={onSecondaryButtonClickHandler}
                    primaryButtonText={primaryButtonText}
                    secondaryButtonText={secondaryButtonText}
                    shouldCloseOnOverlayClick={false}
                    title="brokerClientWarningModal-title"
                />
            );
        }

        if (redirectTo) {
            return <Redirect push to={redirectTo} />;
        }

        return leavingWarningMessage;
    }
}

BrokerClientWarningModal.defaultProps = {
    nextLocation: ''
};

BrokerClientWarningModal.propTypes = {
    immAccessKey: PropTypes.object.isRequired,
    nextLocation: PropTypes.string,
    hideClientWarningModal: PropTypes.func,
    preventGenerateDocumentError: PropTypes.func,
    routerHookCallback: PropTypes.func,
    immbrokerClientWarningModal: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerClientWarningModal;
module.exports.BrokerClientWarningModal = connect(
    state => ({
        immAccessKey: state.accessKeyChange,
        immbrokerClientWarningModal: state.brokerClientWarningModal
    }),
    {
        hideClientWarningModal: BrokerClientWarningModalAction.hideClientWarningModal,
        preventGenerateDocumentError: BrokerClientWarningModalAction.preventGenerateDocumentError
    }
)(withRouter(BrokerClientWarningModal));
